//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "answerDetail",
    data() {
        return {
            questionnaireInfo: {},
            questions: [],
            id: 0,
            qid: 0
        }
    },
    methods: {
        getQuestionnaireById() {
            abp.ajax.get('/api/services/app/Questionnaire/GetQuestionnaireById?id=' + this.qid).then(res => {
                this.questionnaireInfo = {};
                this.questionnaireInfo = res.data.result;
            });
        },
        getQuestions() {
            abp.ajax.get('/api/services/app/AnswerRecord/GetAnswers?id=' + this.id).then(res => {
                this.questions = [];
                this.questions.push(...res.data.result.items);
            });
        },
    },
    created() {
        this.id = parseInt(this.$route.params.id) || 0;
        this.qid = parseInt(this.$route.params.qid) || 0;
        if (this.id > 0) {
            this.getQuestions();
            this.getQuestionnaireById();
        }
    }
}
